import React, { FC } from 'react'
import { useController } from 'react-hook-form'
import { Select } from '@wmgtech/legato'

import { TSelectOption } from 'shared/types'
// import { isRequired } from 'shared/utils/form'

import { FormSelectProps } from './FormSelect.props'
import './FormSelect.scss'

const FormSelect: FC<FormSelectProps> = ({
  control,
  fieldName,
  rules,
  dataTest,
  disabled,
  placeholder,
  options,
  autoComplete = 'off'
}) => {
  const {
    field: { ref, ...restField },
    fieldState: { error }
  } = useController({
    name: fieldName,
    control,
    rules
  })

  return (
    <Select
      className="form-select"
      list={options}
      disabled={disabled}
      data-test={dataTest}
      placeholder={placeholder}
      autoComplete={autoComplete}
      getKey={(el: TSelectOption) => el?.value}
      getTitle={(el: TSelectOption) => el.label}
      onSelect={(el: TSelectOption) => restField.onChange(el.value)}
      validation={{
        message: error?.message,
        ...(error && { type: 'error' })
      }}
      // icon={isRequired(rules) ? 'asterisk' : ''}
      {...restField}
    />
  )
}

export default FormSelect
